export const manifest = {
  screens: {
    scr_7cmzxx: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_fwumo1: { name: "Shop", route: "/shop", position: {"x":160,"y":4180} },
    scr_7t9cke: { name: "Plans", route: "/plans", position: {"x":1560,"y":4180} },
    scr_34dk0f: { name: "Business", route: "/business", position: {"x":160,"y":6160} },
    scr_kni1a1: { name: "Coverage", route: "/coverage", position: {"x":1560,"y":6160} },
  },
  sections: {
    sec_ks76o3: { name: "Home", x: 0, y: 0, width: 1520, height: 1180 },
    sec_6b1mse: { name: "Dashboard", x: 0, y: 1980, width: 1520, height: 1180 },
    sec_u8gpzf: { name: "Products & Pricing", x: 0, y: 3960, width: 2920, height: 1180 },
    sec_7bqg6t: { name: "Information", x: 0, y: 5940, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_ks76o3", children: [
      { kind: "screen", id: "scr_7cmzxx" },
    ] },
    { kind: "section", id: "sec_6b1mse", children: [] },
    { kind: "section", id: "sec_u8gpzf", children: [
      { kind: "screen", id: "scr_fwumo1" },
      { kind: "screen", id: "scr_7t9cke" },
    ] },
    { kind: "section", id: "sec_7bqg6t", children: [
      { kind: "screen", id: "scr_34dk0f" },
      { kind: "screen", id: "scr_kni1a1" },
    ] },
  ],
}
